<template>
  <v-container>
    <v-col>
      <v-sheet height="64">
        <v-toolbar
          color="white"
          flat
        >
          <v-btn
            class="mr-4"
            color="grey darken-2"
            outlined
            @click="setToday"
          > Today </v-btn>
          <v-btn
            color="grey darken-2"
            fab
            small
            text
            @click="prev"
          >
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn
            color="grey darken-2"
            fab
            small
            text
            @click="next"
          >
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar"> {{ $refs.calendar.title }} </v-toolbar-title>
          <v-spacer />
          <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="grey darken-2"
                outlined
                v-bind="attrs"
                v-on="on"
              >
                <span> {{ typeToLabel[type] }} </span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title> Day </v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title> Week </v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title> Month </v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title> 4 days </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          color="primary"
          ref="calendar"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          v-model="focus"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        />
        <v-menu
          offset-x
          :close-on-content-click="false"
          :activator="selectedElement"
          v-model="selectedOpen"
        >
          <v-card
            color="grey lighten-4"
            flat
            min-width="350px"
          >
            <v-toolbar
              dark
              :color="selectedEvent.color"
            >
              <v-toolbar-title v-html="selectedEvent.name" />
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.details" />
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="secondary"
                text
                @click="selectedOpen = false"
              > Cancel </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("job", ["myJobs"]),
    items() { 
      return this.myJobs.filter(myJob => myJob.jobStatus == 1 || myJob.jobStatus == 2) 
    }
  },

  data: () => ({
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    events: [],
    focus: "",
    jobs: [],
    names: [],
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
  }),

  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) { return event.color; },
    setToday() { this.focus = ""; },
    prev() { this.$refs.calendar.prev(); },
    next() { this.$refs.calendar.next(); },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else { open(); }
      nativeEvent.stopPropagation();
    },
    updateRange() {
      const events = [];
      this.items.forEach((job) => {
        const jobColor = this.colors[this.rnd(0, this.colors.length - 1)];
        if (job.scheduledDate) Object.keys(job.scheduledDate).forEach((date) => {
          events.push({
            name: job.jobName,
            start: date,
            end: date,
            color: jobColor,
          });
        });
      });
      this.events = events;
    },
    rnd(a, b) { return Math.floor((b - a + 1) * Math.random()) + a; },
  },

  props: { isLoginUser: Boolean },

  watch: {
    jobs() { this.updateRange(); },
  },
};
</script>
